import { EmailFormData } from './types';

// Validation function
export function validateEmailForm(formData: EmailFormData): Partial<{
  template?: string;
  subject?: string;
  body?: string;
}> {
  const errors: Partial<{
    template?: string;
    subject?: string;
    body?: string;
  }> = {};

  if (!formData.selectedTemplate) {
    errors.template = 'Please select an email template';
  }

  if (!formData.subject.trim()) {
    errors.subject = 'Subject is required';
  }

  if (!formData.body.trim()) {
    errors.body = 'Email body is required';
  }

  return errors;
}
